(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSlideshowV1(container) {
      if (!container || !container.length) return;
      var $slider = container;
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      var autoplay = $slider.attr('data-autoplay') === 'true';
      var autoplaySpeed = parseInt($slider.attr('data-speed'), 10) || 3500;
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        dots: true,
        arrows: false,
        fade: true,
        adaptiveHeight: true,
        prevArrow: '<button type="button" class="prev-slide"><i class="fa fa-long-arrow-left"></i></button>',
        nextArrow: '<button type="button" class="next-slide"><i class="fa fa-long-arrow-right"></i></button>',
        responsive: [
          { breakpoint: 1200, settings: { infinite: true, dots: true, arrows: false } },
          { breakpoint: 1024, settings: { dots: true, arrows: false } },
          { breakpoint: 600, settings: { dots: true, arrows: false } }
        ]
      });
    }

    function initAllSlideshowV1() {
      document.querySelectorAll('[data-section-type="section-slideshow-v1"]').forEach(function(sectionEl) {
        var slider = sectionEl.querySelector('.slick-side-h1');
        if (slider && typeof jQuery !== 'undefined') {
          initSlideshowV1(jQuery(slider));
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        if (typeof jQuery !== 'undefined') initAllSlideshowV1();
      });
    } else if (typeof jQuery !== 'undefined') {
      initAllSlideshowV1();
    }

    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail && event.detail.sectionId && typeof jQuery !== 'undefined') {
        var section = document.getElementById('shopify-section-' + event.detail.sectionId);
        if (section && section.getAttribute('data-section-type') === 'section-slideshow-v1') {
          var slider = section.querySelector('.slick-side-h1');
          if (slider) initSlideshowV1(jQuery(slider));
        }
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      if (event.detail && event.detail.sectionId && typeof jQuery !== 'undefined') {
        var section = document.getElementById('shopify-section-' + event.detail.sectionId);
        if (section) {
          var slider = section.querySelector('.slick-side-h1');
          if (slider && jQuery(slider).hasClass('slick-initialized')) {
            jQuery(slider).slick('unslick');
          }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
